import React, { useState } from "react";
import { observer } from "mobx-react";

import BooksStore from "../../Books/Books.store";
import Radio from "../Radio";
import AppState from "./App.state";

export default observer(function App() {
  const [state] = useState(() => new AppState(new BooksStore()));

  return (
    <div>
      <header>Your books: {state.privateBooksCount}</header>
      <Radio
        currentValue={state.isPrivateOnly}
        label="All books"
        onChange={state.setIsPrivateOnly}
        value={false}
      />
      <Radio
        currentValue={state.isPrivateOnly}
        label="Private books"
        onChange={state.setIsPrivateOnly}
        value={true}
      />
      {state.books.map((book, i) => (
        <div key={i}>
          {book.author}: {book.name}
        </div>
      ))}
      <form onSubmit={state.submit}>
        <input
          onChange={(event) => state.setAuthor(event.target.value)}
          placeholder="Author"
          required
          type="text"
          value={state.author}
        />
        <input
          onChange={(event) => state.setName(event.target.value)}
          placeholder="Name"
          required
          type="text"
          value={state.name}
        />
        <button disabled={!state.isSubmittable} type="submit">
          Add
        </button>
      </form>
    </div>
  );
});
